if(!customElements.get('autopopup-modal')) {
    customElements.define('autopopup-modal', class AutopopupModal extends ModalDialog {
        constructor() {
            super();

            this.delay =  parseInt(this.getAttribute('data-delay'));
            this.frequency = parseInt(this.getAttribute('data-frequency'));

            const lastShowTime = webvista.getCookie('popup_newsletter_frequency');

            // 将频率转换为秒（1天 = 86400秒）
            const frequencyInSeconds = this.frequency * 86400;
            // 获取当前时间的时间戳，单位也是秒
            const currentTime = Math.floor(Date.now() / 1000);

            // 检查当前时间与上次显示时间的差是否大于等于设置的频率
            if (!window.Shopify.designMode && (lastShowTime == null || currentTime - lastShowTime >= frequencyInSeconds)) {
                webvista.setCookie('popup_newsletter_frequency', currentTime.toString());
                setTimeout(() => {
                    this.show();
                }, this.delay * 1000);
            }
        }
    });
}

if(!customElements.get('autopopup-age-verifier')) {
    customElements.define('autopopup-age-verifier', class AutopopupAgeVerifier extends ModalDialog {
        constructor() {
            super();

            this.boundHandleDecline = this.handleDecline.bind(this);
            this.boundHandleSatisfy = this.handleSatisfy.bind(this);
            this.boundHandleReturn = this.handleReturn.bind(this);

            const debugModel = this.hasAttribute('data-debug-model'); // 调试模式，强制每次刷新页面都要弹出年龄验证
            const lastVerified = webvista.getCookie('autopopup_age_verifier');
            const currentTime = Math.floor(Date.now() / 1000);

            if(debugModel || !window.Shopify.designMode && (lastVerified == null || currentTime - lastVerified > 7 * 86400)) {
                this.show();
            }
        }

        show(){
            super.show();

            this.querySelector('button[data-declined]')?.addEventListener('click', this.boundHandleDecline);
            this.querySelector('button[data-satisfied]')?.addEventListener('click', this.boundHandleSatisfy);
        }

        hide() {
            super.hide();

            this.querySelector('button[data-declined]')?.removeEventListener('click', this.boundHandleDecline);
            this.querySelector('button[data-satisfied]')?.removeEventListener('click', this.boundHandleSatisfy);
            this.querySelector('button[data-return]')?.removeEventListener('click', this.boundHandleReturn);
        }

        /**
         * 处理不满足条件
         */
        handleDecline() {
            this.classList.add('age-verifier--has-decline');
            this.querySelector('button[data-return]')?.addEventListener('click', this.boundHandleReturn);
        }

        /**
         * 处理满足条件
         */
        handleSatisfy() {
            const currentTime = Math.floor(Date.now() / 1000);
            webvista.setCookie('autopopup_age_verifier', currentTime);
            this.hide();
        }

        /**
         * 处理返回问题选择页面
         */
        handleReturn() {
            this.classList.remove('age-verifier--has-decline');
        }
    });
}

if (!customElements.get('exit-intent-popup')) {
  customElements.define(
    'exit-intent-popup',
    class ExitIntentPopup extends HTMLElement {
    connectedCallback() {
    if (this._initialised) return;
    this._initialised = true;

    this.maxTime = (parseInt(this.dataset.maxTime, 10) || 0) * 1000;
    this.frequencySeconds = (parseInt(this.dataset.frequency, 10) || 0) * 86400;
    this.startTime = Date.now();
    this.hasFired = false;

    this.init();

    // Theme editor preview support (only show once)
    if (window.Shopify && window.Shopify.designMode) {
        if (window.__exitIntentPreviewShown) return;
        window.__exitIntentPreviewShown = true;

        setTimeout(() => {
        this.show();
        }, 800);
    }
    }

      init() {
        if (window.__exitIntentListenerAdded) return;
        window.__exitIntentListenerAdded = true;

        document.addEventListener('mouseleave', (e) => {
          if (window.__exitIntentFired) return;

          const popup = document.querySelector('exit-intent-popup');
          if (!popup) return;

          const lastShow = parseInt(webvista.getCookie('exit_popup_frequency') || '0', 10);
          const now = Math.floor(Date.now() / 1000);

          // Respect frequency cookie (skip only on live site)
          if (!window.Shopify.designMode && lastShow && (now - lastShow < popup.frequencySeconds)) return;

          const timeSpent = Date.now() - popup.startTime;

          if (e.clientY < 10 && timeSpent < popup.maxTime && !popup.hasFired) {
            popup.show();
          }
        });
      }

      show() {
        this.hasFired = true;
        window.__exitIntentFired = true;

        this.style.display = 'flex';
        this.setAttribute('open', '');

        webvista.setCookie('exit_popup_frequency', Math.floor(Date.now() / 1000).toString());
      }

      hide() {
        this.style.display = 'none';
        this.removeAttribute('open');
      }
    }
  );
}